import apiSlice from './apiSlice';

export interface Candidate {
  name: string;
  email?: string;
  walletAddress: string;
  type: string;
  localImagePath?: string;
  metadataUrl?: string;
  ipfsHash?: string;
  tokenId?: number;
  transactionHash?: string;
}

export interface CreateCertificateRequest {
  title: string;
  issuingAuthority: string;
  issuedAt: string;
  description: string;
  level: string;
  eventId?: string;
  candidates: Candidate[];
}
export interface CreateCertificateResponse {
  message: string;
}
export interface Pagination {
  total: number;
  page: number;
  limit: number;
  pages: number;
}
export interface GetCertificatesResponse {
  data: Certificate[];
  pagination: Pagination;
}

export interface Certificate {
  _id: string;
  recipientName: string;
  title: string;
  issuer: string;
  issuingAuthority: string;
  description: string;
  type?: string;
  eventId?: string;
  level: string;
  issuedAt: string;
  candidates: Candidate[];
  bulkCount: number;
  eventName: string;
  eventLocation: string;
  generatePlaceholders?: boolean;
  url?: string;
  createdAt: string;
  updatedAt: string;
  __v?: number;
}

export interface GetCandidatesResponse {
  data: Candidate[];
  pagination: Pagination;
}
export interface GetCandidatesRequest {
  search?: string;
  page?: number;
  limit?: number;
}
export const certificateApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createCertificate: builder.mutation<CreateCertificateResponse, CreateCertificateRequest>({
      query: (body) => ({
        url: '/certificates',
        method: 'POST',
        body,
      }),
    }),
    bulkUploadCertificates: builder.mutation<{ message: string }, FormData>({
      query: (formData) => ({
        url: '/certificates/bulk-upload',
        method: 'POST',
        body: formData,
      }),
    }),
    getCertificates: builder.query<
      GetCertificatesResponse,
      { search?: string; page?: number; limit?: number }
    >({
      query: ({ search = '', page = 1, limit = 7 }) => ({
        url: '/certificates',
        params: { search, page, limit },
      }),
    }),
    getCertificateById: builder.query<Certificate, string>({
      query: (id) => `/certificates/${id}`,
    }),
    getCandidatesByCertificateId: builder.query<
      GetCandidatesResponse,
      {
        id: string;
        search?: string;
        page?: number;
        limit?: number;
      }
    >({
      query: ({ id, search = '', page = 1, limit = 7 }) => ({
        url: `/candidates/${id}`,
        params: {
          search,
          page,
          limit,
        },
      }),
    }),
  }),
});

export const {
  useCreateCertificateMutation,
  useGetCertificatesQuery,
  useBulkUploadCertificatesMutation,
  useGetCertificateByIdQuery,
  useGetCandidatesByCertificateIdQuery,
} = certificateApi;
